module.exports = __webpack_public_path__ + "static/media/feature-3@2x.2d86c5bc.png";